<div class="component-modal-header">
  <span class="modal-title">{{ title }}</span>
  <button type="button" [disabled]="!isDownloadButtonReady()" class="btn btn-secondary btn-round ml-5" (click)="downloadAll()"><i class="fa fa-download" aria-hidden="true"></i>
    &nbsp;
    <strong>Download All</strong>
  </button>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span class="pi pi-times"></span>
  </button>
</div>
<div class="modal-body session-photo-modal-body">
  <ng-container *ngFor="let upload of uploads">

    <div class="card">
      <div class="card-body">

        <p class="photoCaption">{{ upload.uploadCaption }}</p>

        <ng-container *ngIf="upload.files.length < 1">
          <p>No photo</p>
        </ng-container>

        <div class="photoCarousel">
          <div class="photoWrapper" *ngFor="let file of upload.files">
            <ng-container *ngIf="file.loaded">
              <img [src]="file.srcPath" (click)="viewPhotos(file.photoTotalIndex)" />
            </ng-container>
            <ng-container *ngIf="!file.loaded">
              <div class="skeletonImage"></div>
            </ng-container>

            <span class="fileName">
              {{ file.fileName }}
            </span>
          </div>
        </div>

        <p class="createdDetails">
          {{ upload.createdBy }} - {{ upload.createdDate | date: 'E d MMM yyyy HH:mm' }}
        </p>

      </div>
    </div>
  </ng-container>
</div>
